import React, { useState } from "react";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import PanelTable from "../../../shares/PanelTable";
import OrderNewDetails from "./OrderNewDetails";
import PrintIcon from "@mui/icons-material/Print";
import MuiButton from "../../../shares/MuiButton";

const headersList = [
  { colName: "unique_id", name: " سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "details", name: "جزییات سفارش" },
];
const mobileHeadersList = [
  { colName: "name", name: "تولید کننده" },
  { colName: "unique_id", name: " سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
];

const dataKey = ["unique_id", "created_at", "total"];

// import Others files
const TabOne = (props) => {
  let windowWidth = window.screen.width;
  const { userData } = useUserData();

  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);

  const [isFilterOn, setIsFilterOn] = useState(false);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [requestList, setRequestList] = useState({ results: [] });
  const getRequestListApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/provider_get_admin_request`,
    params: {
      unique_id: codeFilter,
      date: dateFilter,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  // Filter
  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },

    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRequestList({ results: [] });

    getRequestListApi.reFetch();
  };
  // Table
  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderNewDetails
          setNewOerdersList={setRequestList}
          selectedRow={it}
          getRequestListApi={getRequestListApi}
        />
      ),
    },
  ];
  const actionsList = [];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (codeFilter !== null || dateFilter !== null) {
      setIsFilterOn(true);
      setRequestList({ results: [] });

      getRequestListApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    getRequestListApi.reFetch();
  };
  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-current-orders-by-bangle/${codeFilter}/${nameFilter}/${brandFilter}/${orderItemStatusFilter}/${orderItemStatusZeroFilter}`
    // );
    window.open(
      `/print-customers-new-orders-by-bangle/${codeFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      {/* <PanelTemplate sidebarActiveLink="p-new-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های جدید</span>
          </div> */}

      <PanelFilter
        header="فیلتر براساس‌ تاریخ ثبت سفارش:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <div className="flex justify-end">
        <MuiButton
          onClick={handelPrintReport}
          variant="outlined"
          icon={<PrintIcon />}
          color="primary"
          text="چاپ گزارش"
          margin="mr-2"
        />
      </div>
      <PanelTable
        header="لیست سفارش‌های جدید:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={requestList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AddShoppingCartIcon />}
      />

      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
    </>
    // </PanelTemplate>
    // </>
  );
};

export default TabOne;
